
import volteMedium from "../../assets/fonts/volte/Volte-Medium.otf";

const fetchFontUrl = async () => {
    try {
        const response = await fetch(volteMedium);
        return response.url;
    } catch (err) {
        console.error(err);
    }
}

const font = await fetchFontUrl();

export const darkModeUIConfig = {
    formBgColor: '#23272f',
    fieldBgColor: '#343A44',
    fieldBorder: '1px solid #dee2e6',
    fieldOutline: '0',
    fieldLabelColor: '#F3F4F6',
    fieldPlaceholderColor: '#9CA3AF',
    fieldTextColor: '#f6f7f9',
    fieldErrorCodeColor: '#FF6B6B',
    fontFamily: "Volte Medium",
    fontUrl: font,
    labelStyle: {
        fontSize: "14px",
        fontWeight: "400",
    },
    inputStyle: {
        fontSize: "18px",
        fontWeight: "400",
    },
    errorValidationStyle: {
        fontSize: "14px",
        fontWeight: "400",
    },
    separatorColor: "#d5d5d5",
    separatorTextColor: "#F3F4F6",
    customPaddingTermText: "0px",
}

export const defaultUIConfig = {
    formBgColor: '#ffffff',
    fieldBgColor: '#ffffff',
    fieldBorder: '1px solid #dee2e6',
    fieldOutline: '#000 solid 1px',
    fieldLabelColor: '#0d0d0d',
    fieldPlaceholderColor: '',
    fieldTextColor: '#333333',
    fieldErrorCodeColor: '#F50057',
    fontFamily: "Volte Medium",
    fontUrl: font,
    labelStyle: {
        fontSize: "14px",
        fontWeight: "400",
    },
    inputStyle: {
        fontSize: "18px",
        fontWeight: "400",
    },
    errorValidationStyle: {
        fontSize: "14px",
        fontWeight: "400",
    },
    separatorColor: "#d5d5d5",
    separatorTextColor: "#6C6C6C",
    customPaddingTermText: "0px",
}

export const ctpUiConfig = {
    buttonStyle: "FILLED",
    buttonTextCase: "uppercase",
    buttonAndBadgeColor: "#0096D6",
    buttonFilledHoverColor: "#1aa1da",
    buttonOutlinedHoverColor: "#1aa1da",
    buttonDisabledColor: "#0096D699",
    cardItemActiveColor: "#c3d8f5",
    buttonAndBadgeTextColor: "#ffffff",
    linkTextColor: "#0096D6",
    accentColor: "#0096D6",
    fontFamily: "Volte Medium",
    buttonAndInputRadius: "0.375rem",
    cardItemRadius: "0.375rem",
};

export const ctpConfig = {
    enableCTP: true,
    enableCustomerOnboarding: true,
    uiConfig: ctpUiConfig
};

/**
 * Extracts the `exp` (expiration time) claim from a JWT.
 *
 * The JWT payload is base64url-encoded and may contain unicode characters,
 * so it's decoded via `atob` + `decodeURIComponent` to handle multi-byte
 * UTF-8 sequences correctly (plain `atob` alone would corrupt them).
 *
 * @param token - The JWT string in the format `header.payload.signature`.
 * @returns The expiration time as a Unix timestamp (seconds since epoch),
 *          or `undefined` if the token is malformed or has no `exp` claim.
 *
 * @example
 * const exp = getExpFromJwt(token);
 * if (exp && exp * 1000 < Date.now()) {
 *     console.log("Token has expired");
 * }
 */
export const getExpFromJwt = (token: string) => {
    try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

        // Decode base64 to a binary string, then convert each byte to a
        // percent-encoded sequence so `decodeURIComponent` can reassemble
        // multi-byte UTF-8 characters into proper unicode.
        const jsonPayload = decodeURIComponent(
            atob(base64)
            .split("")
            .map((c) => {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        const parsed = JSON.parse(jsonPayload);

        return parsed["exp"];
    } catch (error) {
        console.error("Failed to decode JWT");
    }
};